export default (theme) => ({
    bulkText: {
        cursor: 'pointer',
    },
    cancelBtn: {
        position: 'relative',
        left: 197,
        top: -8,
    },
});
